<template>
  <div v-if="$can('create', 'expense')">
    <b-tabs
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      active-tab-class="font-weight-bold text-success"
      content-class="mt-1"
    >
      <b-tab lazy title="Add Expenses" active>
        <template #title>
          <feather-icon icon="PlusIcon" size="18" />Add Expenses
        </template>

        <hr
          style="
            height: 1.5px;
            border-width: 0;
            color: gray;
            background-color: gray;
          "
        />
        <b-card>
          <b-card-text>
            <b-form @submit.prevent>
              <b-row>
                <b-col md="3">
                  <b-form-group label="Expense Date">
                    <flat-pickr
                      v-model="expenseDate"
                      placeholder="Expense Date"
                      class="form-control borderRadius-10"
                      :config="{ ...$flatPickrConfig }"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="5">
                  <b-form-group label="Movie">
                    <!-- @search="GetAllMovie" -->
                    <v-select
                      @input="getMovieVendors"
                      v-model="selectedMovie"
                      placeholder="Movie"
                      label="full_title"
                      :options="optionMovies"
                      :loading="isMovieLoading"
                      class="borderRadius-10"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Licensee/Licensor/Contact">
                    <v-select
                      :disabled="!selectedMovie ? true : false"
                      v-model="selectedCustomer"
                      placeholder="Licensee/Licensor/Contact"
                      label="company"
                      :options="optionCustomer"
                      :loading="isCustomerLoading"
                      class="borderRadius-10"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                :disabled="
                  !selectedCustomer || !selectedMovie || !expenseDate || loading
                    ? true
                    : false
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 mb-1 md-mb-0 borderRadius-10"
                @click="getReportContracts"
                >Fetch Data</b-button
              >
              <b-card
                v-if="showExpenseSection && revenueTypeArray.length"
                border-variant="success"
                bg-variant="light"
                class="mt-1"
              >
                <b-card-text>
                  <b-row class="mt-1">
                    <b-col>
                      <h5 style="color: #00d09c"><b>Expense Type</b></h5>
                    </b-col>
                    <b-col>
                      <h5 style="color: #00d09c"><b>Territory</b></h5>
                    </b-col>
                    <b-col>
                      <h5 style="color: #00d09c"><b>Amount (CHF)</b></h5>
                    </b-col>
                    <b-col>
                      <h5 style="color: #00d09c"><b>Comment</b></h5>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(item, index) in revenueTypeArray"
                    :key="index"
                    class="mt-1"
                  >
                    <b-col>
                      {{ item.lbl_value1 }}
                      <b-form-input
                        disabled
                        id="from"
                        v-model="item.lbl_name"
                        placeholder="Revenue Type"
                      />
                    </b-col>
                    <b-col>
                      <v-select
                        v-model="item.territory_id"
                        :reduce="(terr) => terr.id"
                        placeholder="Territory"
                        label="ter"
                        :options="optionAvailableTeritory"
                      />
                    </b-col>

                    <b-col>
                      {{ item.lbl_value1 }}
                      <b-form-input
                        id="from"
                        v-model="item.expense_amount"
                        placeholder="Amount"
                        type="number"
                      />
                    </b-col>
                    <b-col>
                      {{ item.lbl_value1 }}
                      <b-form-input
                        id="from"
                        v-model="item.comment"
                        placeholder="Comment"
                        type="text"
                      />
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>

              <b-row
                v-if="showExpenseSection && revenueTypeArray.length"
                class="mt-0"
              >
                <!-- submit and reset -->
                <b-col class="d-flex justify-content-center">
                  <b-button
                    :disabled="
                      !selectedCustomer ||
                      !selectedMovie ||
                      !expenseDate ||
                      loading
                        ? true
                        : false
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1 mb-1 md-mb-0"
                    @click="addExpenseData"
                  >
                    <b-spinner v-if="loading" small /> Submit
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="reset"
                    variant="outline-secondary"
                    class="mb-1 md-mb-0"
                    @click="resetForm"
                  >
                    Reset
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-text>
        </b-card>
      </b-tab>
      <b-tab lazy title="Upload Expense Excel">
        <template #title>
          <feather-icon icon="FileIcon" size="18" />Upload Expense
        </template>
        <hr
          style="
            height: 1.5px;
            border-width: 0;
            color: gray;
            background-color: gray;
          "
        />
        <upload-expense-page />
      </b-tab>
    </b-tabs>
    <div>
      <b-modal
        scrollable
        v-model="modalContract"
        id="modalContract"
        size="xl"
        hide-footer
      >
        <b-table
          bordered
          class="position-relative"
          primary-key="contract_id"
          responsive
          show-empty
          :items="contractsList"
          :fields="fieldsContract"
          hover
        >
          <!-- hover -->
          <template #cell(contract_id)="data">
            {{ data.item.contract_id }}
          </template>
          <template #cell(company)="data">
            <div style="width: max-content">
              <b-badge variant="success">
                {{ data.item.contract_nature
                }}{{ data.item.draft ? "(draft)" : "" }}</b-badge
              ><br />{{ data.item.company }}
            </div>
          </template>
          <template #cell(title)="data">
            <div style="width: max-content" v-html="data.value"></div>
          </template>
          <template #cell(territory)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(right)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(language)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(purchaseDate)="data">
            <b-badge>Contract Date : {{ data.item.purchaseDate }} </b-badge
            ><br />
            <b-badge variant="success" class="mt-1">
              Start : {{ data.item.rStart }} </b-badge
            ><br />

            <b-badge variant="danger" class="mt-1">
              End : {{ data.item.rExpiry }}</b-badge
            >
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                variant="primary"
                size="sm"
                @click="GetContractData(data.item)"
              >
                Select Contract
              </b-button>
            </div>
          </template>
          <template #cell()="data">
            <span class="text-nowrap">{{ data.value }}</span>
          </template>
        </b-table>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BAlert,
  BBadge,
  VBToggle,
  BSpinner,
  BCardText,
  BTabs,
  BTab,
  BModal,
  BTable,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import axios from "axios";
import { getAllMovie } from "@/apiServices/MovieServices";
import * as XLSX from "xlsx";

import { getAllData } from "@/apiServices/MastersServices";
import { AddExpenseData, GetMoviesVendor } from "@/apiServices/RevenueServies";
import ToastificationContentVue from "@core/components/toastification/ToastificationContent.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

import * as ContractServices from "@/apiServices/ContractServices";
import UploadExpensePage from "./UploadExpensePage.vue";
import { debounce } from "@/utils/helpers";

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormFile,
    BAlert,
    BBadge,
    vSelect,
    flatPickr,
    XLSX,
    ToastificationContentVue,
    AppCollapseItem,
    AppCollapse,
    VBToggle,
    BSpinner,
    BTabs,
    BTab,
    BModal,
    BTable,
    UploadExpensePage,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fieldsContract: [
        {
          key: "actions",
          label: "Actions",
          stickyColumn: true,
          variant: "primary",
        },

        {
          key: "company",
          label: "Contact",
        },
        {
          key: "title",
          label: "Movie",
        },
        {
          key: "territory",
          label: "territory",
        },
        {
          key: "right",
          label: "rights",
        },
        {
          key: "language",
          label: "languages",
        },
        {
          key: "purchaseDate",
          label: "contract dates",
        },

        {
          key: "language",
          label: "languages",
        },
        { key: "contract_id", label: "Contract ID" },
      ],
      showSuccess: false,
      insertedDataCount: null,
      showErrorData: false,
      errorExcelData: null,
      BASE_URL: process.env.VUE_APP_BASEURL,
      expenseDate: null,
      expenseFile: null,
      selectedCustomer: null,
      loading: false,
      optionCustomer: [],
      allTeritory: [],
      selectedRight: null,
      expenseAmount: null,
      optionRights: [],
      contractsList: [],
      revenueTypeArray: [],
      optionMovies: [],
      selectedMovie: null,
      isMovieLoading: false,
      isCustomerLoading: false,
      optionTeritory: [],
      selectedTeritory: null,
      modalContract: false,
      showExpenseSection: false,
      uploaded_documents: null,
      contractID: null,
      optionAvailableTeritory: [],
    };
  },

  computed: {},
  watch: {},
  beforeMount() {
    this.GetAllTypes();
    this.GetAllMovie();
  },
  methods: {
    async GetContractData(data) {
      this.GetAllTypes();
      this.contractID = data.contract_id;
      this.optionAvailableTeritory = [];

      let teriName = data.territory.split(",");
      let teriId = data.territory_ids.split(",").map(Number);

      for (let i = 0; i < teriName.length; i++) {
        let p = teriName[i];

        this.optionAvailableTeritory.push({
          ter: p,
          id: teriId[i],
        });
      }
      console.log(this.optionAvailableTeritory, "this.optionAvailableTeritory");
      this.modalContract = false;
      this.showExpenseSection = true;
    },
    async getReportContracts() {
      try {
        const response = await ContractServices.getAllContract({
          movie:
            this.selectedMovie && this.selectedMovie.movie_id
              ? this.selectedMovie.movie_id
              : null,
          vendor: this.selectedCustomer
            ? this.selectedCustomer.vendor_id
            : null,
          contract_nature: "Acquisition",
        });
        this.contractsList = response.data.data.contracts;

        if (!response.data.data.contracts.length) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Acquisition Contract Not Found!",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        } else {
          //if (this.contractsList.length > 1) {
          this.modalContract = true;
          // } else {
          //   // this.addExpenseData(this.contractsList[0].contract_id);
          // }
        }
      } catch (error) {
        console.log("Error in getting Contracts List", error);
      }
    },
    async GetAllTypes() {
      this.revenueTypeArray = [];
      this.optionRights = [];
      try {
        const response = await getAllData({
          master: "revenue_types",
          deleted: "0",
        });
        if (response.data) {
          this.optionRights = response.data.data.rows;

          let newAry = [
            // { lbl_name: "BUMPER PAID", lbl_id: 2 },
            { lbl_name: "OVERAGES PAID", lbl_id: 3 },
            { lbl_name: "DIVERS PAID", lbl_id: 4 },
            { lbl_name: "P&A Expense", lbl_id: 5 },
            {
              lbl_name: "Less Licensor corridor Paid",
              lbl_id: 6,
            },
          ];
          this.optionRights.push(...newAry);

          for (let item of this.optionRights) {
            let defaultObj = {
              lbl_name: item.lbl_name,
              lbl_value1: item.lbl_value1 ? item.lbl_value1 : "",
              lbl_id: item.lbl_id,
              territory_id: item.territory_id,
              expense_amount: item.expense_amount ? item.expense_amount : null,
              comment: item.comment ? item.comment : null,
            };

            this.revenueTypeArray.push(defaultObj);
          }
        }
      } catch (err) {
        console.log("Error in getting territory list ", err);
      }
    },
    async GetAllMovie(searchTerm) {
      // if(!this._debouncedFetchMovies){
      //   this._debouncedFetchMovies = debounce (async(searchTerm)=>{
      this.isMovieLoading = true;
      try {
        //console.log(searchTerm);
        const response = await getAllMovie({ archived: false, draft: false });
        if (response.data) {
          this.optionMovies = response.data.data.data;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      } finally {
        this.isMovieLoading = false;
      }
      //   });
      // }
      // this._debouncedFetchMovies(searchTerm);
    },
    async getMoviesVendorData() {
      this.optionCustomer = [];
      this.isCustomerLoading = true;
      try {
        const response = await GetMoviesVendor({
          movie_id: this.selectedMovie.movie_id,
        });
        if (response.data.status) {
          this.optionCustomer = response.data.data;
          if (this.optionCustomer.length == 1) {
            this.selectedCustomer = this.optionCustomer[0];
          }
        }
      } catch (error) {
        console.log("Error in getting Contracts List");
      } finally {
        this.isCustomerLoading = false;
      }
    },
    async getMovieVendors() {
      this.selectedCustomer = null;
      this.getMoviesVendorData();
    },
    async addExpenseData() {
      this.contract_id = this.contractID;
      this.loading = true;
      try {
        let payload = {
          vendor_id: this.selectedCustomer.vendor_id,
          movie_id: this.selectedMovie.movie_id,
          territory_id: 0,
          expense_date: this.expenseDate,
          expense_amount: null,
          expense_type: null,
          uploaded_documents: this.uploaded_documents,
          revenueTypeArray: this.revenueTypeArray,
          contract_id: this.contract_id,
        };
        const response = await AddExpenseData(payload);
        if (response.data.status) {
          console.log(response.data, "response.data");
          // this.GetAllTypes();
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Added Successfully",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.resetForm();
        } else {
          console.log(response.data, "response.data1");
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.resetForm();
        }

        this.modalContract = false;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log("Error in getting movies list ", err);
      }
    },

    async UploadExpenseData() {
      this.loading = true;
      try {
        const url = this.BASE_URL + "/revenue/uploadBulkExpense";
        const formData = new FormData();
        formData.append("file", this.expenseFile);

        const config = {
          headers: {
            "content-type": "multipart/form-data",
            authorization: localStorage.getItem("access_token"),
          },
        };

        const response = await axios.post(url, formData, config);

        this.loading = false;
        if (response.data.status) this.expenseFile = null;
        if (!response.data.status) {
          if (response.data.data) {
            this.errorExcelData = response.data.data;
          }
          return this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Upload Error",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        return this.$toast({
          component: ToastificationContentVue,
          props: {
            title: response.data.message || "Uploaded successfully",
            icon: "EditIcon",
            variant: "success",
          },
        });
      } catch (err) {
        this.loading = false;
        console.log("Error in UploadExpense ", err);
      }
    },
    downloadErrorExcel() {
      if (this.errorExcelData) {
        let data = this.errorExcelData;
        let sheetName = "Expense";
        let excelName = "ErrorExpenseExcel.xlsx";
        var dataFinal = XLSX.utils.json_to_sheet(data);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataFinal, sheetName);
        XLSX.writeFile(wb, excelName);
      }
    },
    resetForm() {
      console.log("jitu");
      this.selectedCustomer = null;
      this.selectedMovie = null;
      this.selectedTeritory = null;
      this.selectedRight = null;
      this.expenseAmount = null;
      this.expenseDate = null;
      this.expenseFile = null;
      this.revenueTypeArray = [];
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.borderRadius-10 {
  & .vs__dropdown-toggle, .vue-treeselect__control {
    border-radius: 10px !important;
  }
  border-radius: 10px !important;
}

.left-br-10 {
  & .input-group-text {
    border-radius: 10px 0 0 10px !important;
  }
  border-radius: 10px 0 0 10px !important;
}

.right-br-10 {
  border-radius: 0 10px 10px 0 !important;
}

.marginTop-2 {
  margin-top: 2rem !important;
}
</style>
